import { render, staticRenderFns } from "./viewACSTF.vue?vue&type=template&id=47f74e48&scoped=true"
import script from "./viewACSTF.vue?vue&type=script&lang=js"
export * from "./viewACSTF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f74e48",
  null
  
)

export default component.exports